import { request, Response } from '../utils';
import { Session } from '../types';

export const updateGraphPermission = (body: {
  session: Session;
  graphID: string;
  authorizedUsername: string;
  write: boolean;
}): Response<null> => request('update-graph-permission', body);
